import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.25
    }} className="bg-brand-dark border border-brand-gray/30 w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-49">
        <div className="sticky top-0 bg-brand-dark border-b border-brand-gray/30 px-6 py-4 flex items-center justify-between" data-id="element-50">
          <h2 className="font-display font-bold text-xl uppercase tracking-tight" data-id="element-51">
            {title}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors" data-id="element-52">
            <XIcon className="w-6 h-6" data-id="element-53" />
          </button>
        </div>
        <div className="px-6 py-6 text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-54">
          {children}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-darker py-8 border-t border-brand-gray/30 text-center text-gray-500 text-sm" data-id="element-55">
        <div className="container mx-auto px-4" data-id="element-56">
          <div className="flex items-center justify-center gap-6 mb-4" data-id="element-57">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-brand-blue transition-colors underline underline-offset-2" data-id="element-58">
              Política de Privacidad
            </button>
            <span className="text-brand-gray" data-id="element-59">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-brand-blue transition-colors underline underline-offset-2" data-id="element-60">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-61">
            &copy; {new Date().getFullYear()} Protocolo 22. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs max-w-2xl mx-auto" data-id="element-62">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-63">
        {activeModal === 'privacy' && <Modal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-64">
            <p data-id="element-65">
              <strong data-id="element-66">Última actualización:</strong> Abril 2026
            </p>
            <p data-id="element-67">
              En Protocolo 22 nos comprometemos a proteger tu privacidad. Esta
              política describe cómo recopilamos, usamos y protegemos tu
              información personal.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-68">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-69">
              Recopilamos únicamente la información necesaria para procesar tu
              compra: nombre, dirección de correo electrónico y datos de pago.
              No almacenamos información de tarjetas de crédito en nuestros
              servidores.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-70">
              2. Uso de la Información
            </h3>
            <p data-id="element-71">
              Tu información se utiliza exclusivamente para: procesar tu pedido,
              enviarte el producto digital adquirido y brindarte soporte al
              cliente si lo necesitas.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-72">
              3. Protección de Datos
            </h3>
            <p data-id="element-73">
              Utilizamos encriptación SSL y medidas de seguridad estándar de la
              industria para proteger tu información personal durante la
              transmisión y el almacenamiento.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-74">
              4. Compartir Información
            </h3>
            <p data-id="element-75">
              No vendemos, intercambiamos ni transferimos tu información
              personal a terceros. La única excepción son los proveedores de
              servicios de pago necesarios para procesar tu transacción.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-76">5. Cookies</h3>
            <p data-id="element-77">
              Utilizamos cookies para mejorar tu experiencia de navegación y
              analizar el tráfico del sitio. Puedes desactivar las cookies en la
              configuración de tu navegador.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-78">
              6. Tus Derechos
            </h3>
            <p data-id="element-79">
              Tienes derecho a acceder, rectificar o eliminar tu información
              personal en cualquier momento. Para ejercer estos derechos,
              contáctanos a través del correo proporcionado en tu confirmación
              de compra.
            </p>
          </Modal>}

        {activeModal === 'terms' && <Modal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-80">
            <p data-id="element-81">
              <strong data-id="element-82">Última actualización:</strong> Abril 2026
            </p>
            <p data-id="element-83">
              Al adquirir Protocolo 22, aceptas los siguientes términos y
              condiciones. Por favor, léelos detenidamente antes de realizar tu
              compra.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-84">
              1. Producto Digital
            </h3>
            <p data-id="element-85">
              Protocolo 22 es un producto educativo en formato digital (PDF). Al
              completar tu compra, recibirás acceso inmediato para descargar el
              material.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-86">
              2. Uso Personal
            </h3>
            <p data-id="element-87">
              El contenido adquirido es para uso personal e intransferible.
              Queda prohibida la reproducción, distribución o reventa del
              material sin autorización expresa.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-88">
              3. Resultados
            </h3>
            <p data-id="element-89">
              Los resultados pueden variar de persona a persona. Protocolo 22 es
              un programa educativo y no garantiza resultados específicos. El
              éxito depende del compromiso y la constancia del usuario.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-90">
              4. Aviso de Salud
            </h3>
            <p data-id="element-91">
              Este producto no sustituye el consejo médico profesional. Si
              tienes una condición médica, consulta a tu médico antes de iniciar
              cualquier programa. No somos profesionales de la salud y el
              contenido es puramente educativo.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-92">
              5. Política de Reembolso
            </h3>
            <p data-id="element-93">
              Debido a la naturaleza digital del producto, todas las ventas son
              finales. Sin embargo, si experimentas problemas técnicos con la
              descarga, nuestro equipo de soporte te asistirá para resolver el
              inconveniente.
            </p>
            <h3 className="font-bold text-white text-base mt-4" data-id="element-94">
              6. Modificaciones
            </h3>
            <p data-id="element-95">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Las modificaciones entrarán en vigor inmediatamente
              después de su publicación en este sitio.
            </p>
          </Modal>}
      </AnimatePresence>
    </>;
}